export default __webpack_public_path__ + "static/media/Administration_Hover.f4d054eb.png";